import React, { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../services/db";

const AuthContext = createContext();

const AuthProviders = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage on initial mount
  useEffect(() => {
    const loadUserFromStorage = () => {
      try {
        const storedUser = localStorage.getItem('sb-user');
        const accessToken = localStorage.getItem('sb-access-token');
        
        if (storedUser && accessToken) {
          setUser(JSON.parse(storedUser));
        }
      } catch (error) {
        console.error('Error loading user from storage:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUserFromStorage();
  }, []);

  // Login function that updates context and localStorage
  const login = (userData, session) => {
    // Store user in context
    setUser(userData);
    // Store in localStorage
    localStorage.setItem('sb-user', JSON.stringify(userData));
    localStorage.setItem('sb-access-token', session.access_token);
    localStorage.setItem('sb-refresh-token', session.refresh_token);
    localStorage.setItem('sb-expires-at', session.expires_at);
  };

  // Logout function
  const logout = async() => {
     try {
      // Sign out from Supabase auth
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        console.error('Supabase signOut error:', error);
      }
      
      // Clear user from context
      setUser(null);
      
      // Clear all localStorage items
      localStorage.removeItem('sb-user');
      localStorage.removeItem('sb-access-token');
      localStorage.removeItem('sb-refresh-token');
      localStorage.removeItem('sb-expires-at');
      
      // Redirect to login
      window.location.href = '/login';
      
    } catch (error) {
      console.error('Logout error:', error);
      // Even if there's an error, clear local state and redirect
      setUser(null);
      localStorage.clear();
      window.location.href = '/login';
    }
  };

  // Update user data
  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('sb-user', JSON.stringify(userData));
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      logout,
      updateUser,
      isAuthenticated: !!user
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuths = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuths must be used within an AuthProviders');
  }
  return context;
};

export default AuthProviders;